<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>


    <el-card class="box-card mt-2">
      <FXUserImport></FXUserImport>
    </el-card>


    <el-card class="box-card mt-2">
      <p>同步党组织信息</p>
      <FXPartyorgImport></FXPartyorgImport>
    </el-card>
 

  </div>
</template>




<script>
import { BaseVue } from "@/mixin/index";
import { FXUserImport, FXPartyorgImport } from '@/views/module/fxuser/comp/';

export default {
  name: "FXUser",
  
  mixins: [BaseVue],
  
  components: {
    FXUserImport,
    FXPartyorgImport
  },
  
  beforeMount() {
    // 组件挂载前的逻辑
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>
<style scoped>
</style>